import React, { useEffect } from 'react';
import ConfirmDialog from '@/components/organism/ConfirmDialog';
import Input from '@/components/atom/Input';
import Label from '@/components/atom/Label';
import Typo from '@/components/atom/Typo';

interface ExcelPasswordDialogProps {
  submitCallback?: (password: string) => Promise<any> | void;
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

function ExcelPasswordDialog({
  submitCallback,
  isOpen = false,
  setOpen,
}: ExcelPasswordDialogProps) {
  const [password, setPassword] = React.useState<string>('');

  useEffect(() => {
    if (isOpen) {
      setPassword('');
    }
  }, [isOpen]);

  return (
    <ConfirmDialog
      title="엑셀 비밀번호 설정"
      open={isOpen}
      onOpenChange={setOpen}
      onOk={() => submitCallback?.(password)}
    >
      <div className="flex flex-col gap-[24px]">
        <div className="flex flex-col gap-[8px]">
          <Label className="w-full !text-b16r">엑셀 비밀번호</Label>
          <Input
            id="excel-password"
            name="excel-password"
            autoFocus={true}
            type="password"
            value={password}
            autoComplete="new-password"
            onClear={() => setPassword('')}
            onChange={e => setPassword(e.target.value)}
            placeholder="다운로드한 엑셀의 비밀번호를 설정해주세요"
            onEnterKeyDown={() => {
              setOpen(false);
              submitCallback?.(password);
            }}
          />
        </div>
        <div className="flex flex-col gap-[8px]">
          <Typo typoType="b14m" typoColor="gray7">
            기본 비밀번호
          </Typo>
          <div className="flex items-center">
            <span className="mx-[8px] h-[3px] w-[3px] rounded-3xl bg-gray5" />
            <Typo typoType="b14r" typoColor="gray5">
              비밀번호를 설정하지 않을 경우 관리자 기본 비밀번호로 설정됩니다.
            </Typo>
          </div>
        </div>
      </div>
    </ConfirmDialog>
  );
}

export default React.memo(ExcelPasswordDialog);
